import { Breakpoints, Button, Colors, InlineText, Text } from '@helloself/hello-self-ui';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { recordEvent } from '../../../analytics/product';
import Logo from '../Logo';

export const Footer = () => {
    const history = useHistory();

    const handleGoToHelloSelfWebsite = () => {
        recordEvent({
            name: 'Clicked HelloSelf.com',
            attributes: {
                path: history.location.pathname,
                category: 'Footer',
                'Clicked from Location': 'Footer',
            },
        });
        window.open('https://www.helloself.com/', '_blank', 'noopener noreferrer');
    };

    return (
        <StyledFooter>
            <Text textSize="xsmall" textAlign="center" fontWeight="600">
                HelloSelf Limited {new Date().getFullYear()} © All rights reserved
            </Text>
            {/* // TODO: Update with the UI lib once updated */}
            <Logo color="#0B2621" />
            <Text textSize="xsmall" textAlign="center" fontWeight="600">
                Visit&nbsp;
                <Button display="transparent" size="auto" shape="auto" onClick={handleGoToHelloSelfWebsite}>
                    <InlineText fontWeight="600" textColor={Colors.darkGreen}>
                        HelloSelf.com
                    </InlineText>
                </Button>
                &nbsp;for our privacy, policies and T&C’s
            </Text>
        </StyledFooter>
    );
};

const StyledFooter = styled.footer`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // If you're changing this height, be wary some containers use it, take a look at Messaging.tsx Line 94
    padding: 17px 40px;
    background-color: ${Colors.white};
    @media (min-width: ${Breakpoints.desktopPxString}) {
        flex-direction: row;
        justify-content: space-between;
    }
    z-index: 1;
`;
